var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative flex", attrs: { id: "form-base" } },
    [
      _c(
        "div",
        {
          staticClass:
            "form-base relative w-120 flex flex-col justify-between gap-12 flex-shrink-0 overflow-y-auto bg-pure-white border-r border-slate-400",
          attrs: { id: "form-panel" }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass:
                    "sticky top-0 z-10 px-6 h-12 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
                },
                [
                  _c("BlBreadcrumbs", {
                    attrs: { breadcrumbs: _vm.breadcrumbs }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sticky top-12 z-10 px-6 h-22 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
                },
                [_c("BlTextTitle3", { attrs: { text: "Parents' Form" } })],
                1
              ),
              _vm._v(" "),
              _c("ParentFormPanel")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sticky bottom-0 h-14 w-full flex-shrink-0 flex items-center justify-center gap-2 bg-pure-white border-t border-slate-400 hover:bg-hover-state",
              class: [
                _vm.newSectionLoading ? "pointer-events-none" : "cursor-pointer"
              ],
              on: { click: _vm.onAddsection }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-6 w-6 flex-shrink-0 flex items-center justify-center rounded bg-red-salmon"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: {
                      icon: "rectangle-dashed",
                      color: "white",
                      tooltip: "Section"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextSubtitle3", {
                staticClass: "text-light-purple",
                attrs: { text: "Add section" }
              }),
              _vm._v(" "),
              _vm.newSectionLoading
                ? _c("div", { staticClass: "blum-loader-sm" })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-base relative overflow-y-auto",
          style: { width: "calc(100vw - 30rem)" },
          attrs: { id: "form-body" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky top-0 z-10 px-6 h-16 flex items-center justify-end bg-slate-300 border-b border-slate-400"
            },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/center/client-acquisition/form/preview",
                    target: "_blank"
                  }
                },
                [_c("BlInputButton", { attrs: { label: "Preview form" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.fetchLoading
            ? _c("div", { staticClass: "h-full grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : _vm.parentForm
            ? _c(
                "div",
                {
                  key: _vm.parentForm.updated_at,
                  staticClass: "w-full py-5 flex flex-col items-center gap-5"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-light-purple-200 rounded-xl"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nameInput,
                            expression: "nameInput"
                          }
                        ],
                        staticClass:
                          "name-input mb-2 focus:border-light-purple",
                        attrs: {
                          type: "text",
                          name: "form_name",
                          id: "form_name",
                          placeholder: "Form title"
                        },
                        domProps: { value: _vm.nameInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nameInput = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.descriptionInput,
                            expression: "descriptionInput"
                          }
                        ],
                        staticClass:
                          "description-input focus:border-light-purple",
                        attrs: {
                          type: "text",
                          name: "form_description",
                          id: "form_description",
                          placeholder: "Description (optional)"
                        },
                        domProps: { value: _vm.descriptionInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.descriptionInput = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.parentFormSections, function(section) {
                    return _c("ParentFormSection", {
                      key: section.id,
                      attrs: { section: section }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33d0a9c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33d0a9c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/salesPipeline/Form.vue
// module id = null
// module chunks = 